module.exports = __webpack_public_path__ + "static/media/08_background.f4cf4fdc.png";